import { Button, JaneGoldIcon, Typography } from '@iheartjane/reefer';
import { useEffect, useState } from 'react';

import {
  useFilterSearchParams,
  useProductSearchFilters,
} from '@jane/bloom/hooks/filters';

const filterKey = 'hasBrandDiscount';

export function JaneGoldFilter() {
  const { janeGoldFilterOption } = useProductSearchFilters();
  const [searchParams, setSearchParams] = useFilterSearchParams();
  const [isSelected, setIsSelected] = useState(
    searchParams.has('hasBrandDiscount')
  );

  useEffect(() => {
    setIsSelected(searchParams.has(filterKey));
  }, [searchParams]);

  const clearFilter = () => {
    setSearchParams(
      (prev) => {
        prev.delete(filterKey);
        return prev;
      },
      { preventScrollReset: true }
    );
  };

  const setFilter = () => {
    setSearchParams(
      (prev) => {
        prev.set(filterKey, '');
        return prev;
      },
      { preventScrollReset: true }
    );
  };

  return (
    <Button
      variant={isSelected ? 'primary' : 'tertiary'}
      mx={4}
      label={
        <Typography
          variant="body-semibold"
          color={isSelected ? 'grays-white' : 'grays-black'}
        >
          Jane Gold ({janeGoldFilterOption?.count ?? 0})
        </Typography>
      }
      startIcon={<JaneGoldIcon color="gold" />}
      onClick={() => {
        if (isSelected) {
          setIsSelected(false);
          clearFilter();
        } else {
          setIsSelected(true);
          setFilter();
        }
      }}
    />
  );
}
